import { render, staticRenderFns } from "./inspection.vue?vue&type=template&id=0974eadb&scoped=true&"
import script from "./inspection.vue?vue&type=script&lang=js&"
export * from "./inspection.vue?vue&type=script&lang=js&"
import style0 from "./inspection.vue?vue&type=style&index=0&id=0974eadb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0974eadb",
  null
  
)

export default component.exports